import * as XLSX from "xlsx";

const exportToExcel = (data, fileName) => {

  const formatDate = (dateValue) => {
    if (!dateValue) return "";
    const date = new Date(dateValue);
    return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
  };

  const entradasData = data
    .filter(item => item.isinput === true)
    .map(data => [
      (data.preiddoc_sheet) + (data.sufiddoc_sheet) || "",
      formatDate(data.date_sheet) || "",
       formatDate(data.end_date_sheet) || "",
      data.ori_tras_tradename || "",
      data.ori_tras_nima || "",
      data.ori_tras_postalcode || "",
      data.opt_tras_tradename || "",
      data.opt_tras_nima || "",
      data.amount || "",
      data.codeler || "",
      data.namecodeler || "",
      data.rel_trans_tradename || "",
      data.rel_trans_nima || "",
      data.column1 || "",
      data.column1 || ""
    ]);

  const salidasData = data
    .filter(item => item.isoutput === true)
    .map((data, index) => [
      index + 1,
      formatDate(data.date_sheet) || "",
      formatDate(data.end_date_sheet) || "",
      data.namecodeler || "",
      data.codeler || "",
      data.dest_tras_tradename || "",
      data.dest_tras_nima || "",
      data.dest_tras_inscription || "",
      data.dest_tras_postalcode || "",
      data.nametreatment || data.namedangerousness || "",
      data.rel_trans_tradename || "",
      data.rel_trans_nima || "",
      data.amount || 0,
      data.column1 || "",
      data.column2 || "",
    ]);

  const entradasHeader = [
    "Nº D.I.",
    "FECHA INICIO",
    "FECHA FIN",
    "RAZÓN SOCIAL ORIGEN DEL TRASLASO",
    "NIMA",
    "MUNICIPIO",
    "RAZÓN SOCIAL OPERADOR DEL TRASLADO",
    "NIMA",
    "CANTIDAD",
    "CÓDIGO LER",
    "DESCRIPCIÓN LER",
    "RAZÓN SOCIAL TRANSPORTISTA",
    "NIMA",
    "INFORMACIÓN ADICIONAL",
    "INFORMACIÓN ADICIONAL"
  ];

  const salidasHeader = [
    "NÚMERO DE REGISTRO",
    "FECHA INICIO",
    "FECHA FIN",
    "DESCRIPCIÓN LER",
    "CÓDIGO LER",
    "RAZÓN SOCIAL DESTINO DEL TRASLADO",
    "NIMA",
    "NÚMERO DE REGISTRO DE PyGR",
    "MUNICIPIO",
    "OPT. TRAT. DESTINO",
    "RAZÓN SOCIAL TRANSPORTISTA",
    "NIMA",
    "CANTIDAD",
    "INFORMACIÓN ADICIONAL",
    "INFORMACIÓN ADICIONAL"
  ];

  const entradasWorksheet = XLSX.utils.aoa_to_sheet([entradasHeader, ...entradasData]);
  const salidasWorksheet = XLSX.utils.aoa_to_sheet([salidasHeader, ...salidasData]);

  // --- Añadimos filtros automáticos ---
  entradasWorksheet['!autofilter'] = { ref: XLSX.utils.encode_range({ s: { c: 0, r: 0 }, e: { c: entradasHeader.length - 1, r: 0 } }) };
  salidasWorksheet['!autofilter'] = { ref: XLSX.utils.encode_range({ s: { c: 0, r: 0 }, e: { c: salidasHeader.length - 1, r: 0 } }) };

  // --- Estilo cabeceras (azul clarito, negrita, centrado) ---
  const headerStyle = {
    fill: { fgColor: { rgb: "CCE5FF" } }, // azul claro
    font: { bold: true },
    alignment: { horizontal: "center", vertical: "center" },
  };

  const applyHeaderStyle = (ws, headers) => {
    headers.forEach((_, colIndex) => {
      const cellAddress = XLSX.utils.encode_cell({ c: colIndex, r: 0 });
      if (!ws[cellAddress]) return;
      if (!ws[cellAddress].s) ws[cellAddress].s = {};
      ws[cellAddress].s = headerStyle;
    });
  };

  applyHeaderStyle(entradasWorksheet, entradasHeader);
  applyHeaderStyle(salidasWorksheet, salidasHeader);

  const workbook = XLSX.utils.book_new();
  const safeFileName = fileName.endsWith(".xlsx") ? fileName : `${fileName}.xlsx`;

  XLSX.utils.book_append_sheet(workbook, entradasWorksheet, "ENTRADAS");
  XLSX.utils.book_append_sheet(workbook, salidasWorksheet, "SALIDAS");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array", cellStyles: true });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = safeFileName;
  a.click();
  window.URL.revokeObjectURL(url);
};

export default exportToExcel;
